import { customAxios } from './customAxios';
export function closeAdvMr(idPratica) {

    const config = {
        params: { idPratica: idPratica },
        headers: {
            "AuthToken": JSON.parse(localStorage.getItem('token')),
        },
    }

    const closeAdvMrRequest = customAxios.get(
        process.env.REACT_APP_BACKEND_HOST + '/'+process.env.REACT_APP_PATH_NEW_PREFIX+'/closeAdvMRandAddAdvAR',
        config)
    return closeAdvMrRequest
}
